import React from "react";
import { defineMessages } from "react-intl";
import WideSplitView from "./WideSplitView";

const messages = defineMessages({
  inspectPlaceholder: {
    id: "inspectPlaceholder",
    defaultMessage: "Select a record to see its detail,\nor tap the + button to add a new one."
  }
});

/**
 * Context used by List & Inspect components so that the list query can be refetched whenenver the inspect needs it.
 * 
 * See functions below for detail on what each does.
 */
export const ListInspectContext = React.createContext({
  getRefetchQuery: () => {},

  setQuery: () => {},
  setVariables: () => {}
});

/**
 * Special WideSplitView component for List & Inspect components where the default placeholder is applicable for Inspect pages.
 * 
 * Props:
 * - queryVariables: Variables to pass to the list query, also set in context so the list can be refetch when the inspect requires to.
 */
class ListInspect extends React.Component {

  constructor(props) {
    super(props);
    this.variables = {};

    this.getRefetchQuery = this.getRefetchQuery.bind(this);
    this.setQuery = this.setQuery.bind(this);
    this.setVariables = this.setVariables.bind(this);
  }

  /**
   * Obtains the "refetchQuery" object used by a mutation to refetch the query.
   */
  getRefetchQuery() {
    const { query, variables } = this;

    return query && {query, variables};
  }

  /**
   * Sets the GraphQL query used by the List to fetch the data. This is used by the getRefetchQuery function to produce the object to refetch a query after a mutation.
   */
  setQuery(query) {
    this.query = query;
  }

  /**
   * Sets only the variables that have changed for the current query.
   * 
   * Used by the list to update the offset (for paging) or any filter that might be set by the user.
   */
  setVariables(variables) {
    this.variables = {...this.variables, ...variables};
  }

  render() {
    const { props, getRefetchQuery, setQuery, setVariables } = this;

    return (
      <ListInspectContext.Provider value={{getRefetchQuery, setQuery, setVariables}}>
        <WideSplitView message={messages.inspectPlaceholder} {...props} />
      </ListInspectContext.Provider>
    );
  }
}

export default ListInspect;
